module.exports = __webpack_public_path__ + "img/image82.bb20e507.png";